export default __webpack_public_path__ + "static/media/285hz-tissue-healing-regeneration.cb24224a.mp3";